module.exports = __webpack_public_path__ + "img/3.d3f6d7f5.webp";